import { render } from "./message-push.vue?vue&type=template&id=a7f9e21e&scoped=true&ts=true"
import script from "./message-push.vue?vue&type=script&lang=ts"
export * from "./message-push.vue?vue&type=script&lang=ts"

import "./message-push.vue?vue&type=style&index=0&id=a7f9e21e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f9e21e"]])

export default __exports__